import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Swiftdzireonrentinmumbai() {



  const cardData =
  {
    keyword: 'Swift Dzire on Rent in Mumbai ',
    heading: 'Shambhu Cabs: Swift Dzire on Rent in Mumbai',
    headingDescription: 'Shambhu Cabs offers Swift Dzire on Rent in Mumbai, providing a safe, comfortable, and budget-friendly travel option for daily commuting, airport transfers, corporate travel, outstation trips, and city rides. Our well-maintained Swift Dzire cars come with spacious seating, clean interiors, and skilled chauffeurs to ensure a smooth and hassle-free travel experience. Whether you are traveling from South Mumbai to Thane, Andheri to Navi Mumbai, or planning an intercity journey, Shambhu Cabs provides doorstep pickup and timely service. With flexible hourly, one-way, and round-trip rental options, transparent pricing, and 24/7 booking support, Shambhu Cabs is your trusted choice for Swift Dzire rental in Mumbai for comfort, convenience, and reliability.',

    top: 'Top Places to Visit in Mumbai with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch built to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Today, visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade filled with tourists, performers, and vendors. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel that connects Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time, symbolizing Mumbai’s modern urban growth. The best time to view the Sea Link is during sunrise, sunset, or night when the bridge lights create a spectacular skyline view."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of India’s oldest and most famous flea markets, Chor Bazaar is known for its antique furniture, vintage Bollywood posters, cameras, gramophones, lamps, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, interior designers, and collectors frequent the area to discover unique treasures. It remains a buzzing hotspot for culture, photography, and old-world charm."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread over 100 sq km, Sanjay Gandhi National Park is Mumbai’s green lung and a biodiversity hotspot. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling routes, and the ancient Kanheri Caves inside the park. Home to leopards, deer, monkeys, and hundreds of bird species, it offers a jungle retreat in the middle of the city. The park is perfect for trekking, wildlife photography, and peaceful nature escapes."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is located atop a hill in Bandra offering beautiful views of the sea. The church is known for its stunning Gothic architecture, peaceful interiors, and the annual Bandra Fair held in September. Devotees across religions visit to seek blessings, light candles, and enjoy the serene surroundings. It is one of Mumbai’s most significant spiritual and cultural landmarks."
  }
],




"services": [
  {
    "name": "Dzire Rental Mumbai",
    "description": "Dzire Rental Mumbai provides comfortable and reliable Dzire sedans for city rides, airport transfers, and outstation trips. With professional chauffeurs, well-maintained vehicles, and 24×7 availability, passengers can enjoy smooth and safe journeys. Ideal for solo travelers, couples, and small families, the service also offers easy online booking and transparent pricing for a hassle-free experience."
  },
  {
    "name": "Sedan Car on Rent Mumbai",
    "description": "Sedan Car on Rent Mumbai offers a fleet of Dzire sedans and other sedan models for local and outstation travel. Perfect for office commutes, airport pickups, and family outings, the service ensures punctual pickups, experienced drivers, and clean, AC-enabled vehicles. Flexible rental plans and secure online booking make it convenient for all travelers."
  },
  {
    "name": "Chauffeur Dzire Mumbai",
    "description": "Chauffeur Dzire Mumbai provides professional drivers with Dzire sedans for safe, timely, and comfortable travel. Whether for corporate use, airport transfers, or personal trips, customers enjoy courteous drivers, well-maintained cars, and stress-free travel. The service supports hourly, daily, and long-distance rental options."
  },
  {
    "name": "Dzire Taxi Hire Mumbai",
    "description": "Dzire Taxi Hire Mumbai ensures reliable and affordable travel in Dzire sedans for local, airport, and outstation rides. With experienced chauffeurs, 24×7 service, and online booking options, passengers can plan their trips efficiently. Ideal for business trips, family travel, and city rides with comfort and safety."
  },
  {
    "name": "Affordable Dzire Rental",
    "description": "Affordable Dzire Rental provides budget-friendly Dzire taxi services in Mumbai without compromising comfort or safety. Passengers can enjoy air-conditioned sedans with professional drivers for city, airport, or long-distance travel. The service includes transparent fare estimates and flexible booking plans for daily, hourly, or outstation rides."
  },
  {
    "name": "Dzire Local Ride Mumbai",
    "description": "Dzire Local Ride Mumbai offers point-to-point travel within the city using Dzire sedans. With experienced drivers, timely pickups, and comfortable AC cars, passengers can travel conveniently for office commutes, errands, and social visits. 24×7 availability and easy online booking enhance the travel experience."
  },
  {
    "name": "Dzire Outstation Cab Mumbai",
    "description": "Dzire Outstation Cab Mumbai provides long-distance travel in Dzire sedans for trips to nearby cities and towns. Professional chauffeurs, well-maintained vehicles, and transparent pricing ensure a safe and comfortable journey for families, groups, and business travelers. Flexible rental packages cater to one-way or round trips."
  },
  {
    "name": "Dzire AC Taxi Mumbai",
    "description": "Dzire AC Taxi Mumbai ensures a cool and comfortable travel experience in air-conditioned Dzire sedans. Suitable for city travel, airport transfers, and outstation trips, passengers enjoy safe, reliable, and timely service with online booking options and professional chauffeurs."
  },
  {
    "name": "Mumbai Airport Dzire Cab",
    "description": "Mumbai Airport Dzire Cab offers reliable and punctual transfers to and from Mumbai airports in Dzire sedans. With experienced drivers, clean AC vehicles, and 24×7 availability, passengers enjoy hassle-free airport rides. Online booking and transparent fares make planning easy and convenient."
  },
  {
    "name": "Dzire Long Distance Cab",
    "description": "Dzire Long Distance Cab provides comfortable travel for long routes in Dzire sedans. Ideal for business trips, family vacations, and intercity travel, the service includes experienced drivers, AC vehicles, real-time tracking, and flexible pricing options for one-way or round trips."
  },
  {
    "name": "Dzire Corporate Cab Mumbai",
    "description": "Dzire Corporate Cab Mumbai offers chauffeur-driven Dzire sedans for employee transport, business trips, and corporate events. Professional drivers, timely pickups, and premium service ensure a smooth travel experience. Flexible billing and online booking make it suitable for corporate needs."
  },
  {
    "name": "Swift Dzire Hourly Rental",
    "description": "Swift Dzire Hourly Rental allows passengers to hire Dzire sedans on an hourly basis for city travel, meetings, or personal errands. With professional chauffeurs, air-conditioned comfort, and convenient booking, passengers enjoy cost-effective and flexible travel solutions in Mumbai."
  },
  {
    "name": "Dzire Day Rental Mumbai",
    "description": "Dzire Day Rental Mumbai offers full-day Dzire sedan hire for sightseeing, city tours, corporate travel, or family outings. Passengers benefit from experienced drivers, AC vehicles, and hassle-free online booking with flexible payment options and transparent pricing."
  },
  {
    "name": "Dzire for Office Ride Mumbai",
    "description": "Dzire for Office Ride Mumbai provides comfortable and timely transportation for employees using Dzire sedans. Ideal for daily commutes, the service ensures punctual pickups, professional drivers, and a safe, air-conditioned journey to and from offices."
  },
  {
    "name": "Dzire Car Hire Near Me",
    "description": "Dzire Car Hire Near Me allows passengers to quickly book nearby Dzire sedans for immediate travel needs. With 24×7 availability, experienced drivers, and well-maintained AC vehicles, passengers enjoy a convenient, safe, and comfortable ride in Mumbai."
  },
  {
    "name": "Mumbai Dzire Service",
    "description": "Mumbai Dzire Service offers comprehensive Dzire sedan rental solutions, including local rides, airport transfers, outstation travel, and corporate transport. Passengers enjoy professional drivers, comfortable vehicles, transparent pricing, and easy online booking for a hassle-free experience."
  },
  {
    "name": "Dzire Ride Booking Mumbai",
    "description": "Dzire Ride Booking Mumbai provides quick and convenient online booking for Dzire sedans in Mumbai. Passengers can choose from hourly, daily, or long-distance rental packages, ensuring safe, comfortable, and timely travel with experienced chauffeurs and air-conditioned vehicles."
  }
],

"tableData": [
  ["Dzire Rental Mumbai", "Sedan Car on Rent Mumbai"],
  ["Chauffeur Dzire Mumbai", "Dzire Taxi Hire Mumbai"],
  ["Affordable Dzire Rental", "Dzire Local Ride Mumbai"],
  ["Dzire Outstation Cab Mumbai", "Dzire AC Taxi Mumbai"],
  ["Mumbai Airport Dzire Cab", "Dzire Long Distance Cab"],
  ["Dzire Corporate Cab Mumbai", "Swift Dzire Hourly Rental"],
  ["Dzire Day Rental Mumbai", "Dzire for Office Ride Mumbai"],
  ["Dzire Car Hire Near Me", "Mumbai Dzire Service"],
  ["Dzire Ride Booking Mumbai", "—"]
],



"whychoose": [
  {
    "WhyChooseheading": "Swift Dzire on Rent in Mumbai with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers Swift Dzire on rent in Mumbai, perfect for city travel, airport transfers, and comfortable point-to-point rides."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Swift Dzire",
    "WhyChoosedescription": "Travel in a spacious, air-conditioned, and regularly serviced Swift Dzire to ensure a smooth and pleasant ride in Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Travel",
    "WhyChoosedescription": "Our professional drivers are familiar with Mumbai routes, ensuring timely, safe, and hassle-free journeys in a Swift Dzire."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer clear, upfront pricing—fuel, tolls, and driver allowances included—making your Swift Dzire rental stress-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and real-time updates."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored for your Swift Dzire travel needs in Mumbai."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Swift Dzire cars are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Swift Dzire rental in Mumbai convenient and worry-free."
  }
]

























  }

const faqData = [
  {
    question: 'Can I rent a Swift Dzire in Mumbai with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs provides Swift Dzire on rent in Mumbai for local travel, airport transfers, and outstation trips with comfort and reliability.',
  },
  {
    question: 'How can I book a Swift Dzire on rent in Mumbai?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team for quick and hassle-free booking.',
  },
  {
    question: 'Is Swift Dzire suitable for family and group travel in Mumbai?',
    answer: 'Yes, the Swift Dzire is a comfortable sedan ideal for small families, couples, and individual travelers within Mumbai.',
  },
  {
    question: 'Are drivers experienced for Swift Dzire rental in Mumbai?',
    answer: 'Absolutely. Our drivers are licensed, professional, and well-versed with Mumbai city routes to ensure a safe and timely journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for Swift Dzire rental?',
    answer: 'Yes, you can select any pickup and drop-off points within Mumbai according to your convenience.',
  },
  {
    question: 'Is Swift Dzire rental available 24x7 in Mumbai?',
    answer: 'Yes, Shambhu Cabs provides round-the-clock Swift Dzire rental services to accommodate any travel schedule.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Swift Dzire rentals?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene guidelines for passenger well-being.',
  },
  {
    question: 'What payment options are available for Swift Dzire rental in Mumbai?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments for Swift Dzire bookings.',
  },
  {
    question: 'Is customer support available during Swift Dzire rental trips in Mumbai?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Swift Dzire rental journey in Mumbai.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Mehra',
    feedback: 'Renting a Swift Dzire from Shambhu Cabs in Mumbai was very convenient. The car was clean, and the driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Kapoor',
    feedback: 'Highly recommend Shambhu Cabs for Swift Dzire rentals in Mumbai. Smooth booking process and comfortable ride.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Swift Dzire on Rent in Mumbai",
  "image": "https://www.shambhucab.com/assets/images/swift-dzire-rental-mumbai.jpg",
  "description": "Rent a Swift Dzire in Mumbai with Shambhu Cabs. Ideal for local rides, airport transfers, outstation trips, and corporate travel. Choose from hourly or daily rentals with AC, chauffeur service, and safe, reliable booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/swift-dzire-on-rent-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Swift Dzire on Rent in Mumbai | Sedan Car Hire | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Swift Dzire on rent in Mumbai with Shambhu Cabs. Ideal for local rides, airport transfers, outstation trips, and corporate travel. Hourly and daily rentals available with AC and chauffeur service."
  />

  <meta
    name="keywords"
    content="Dzire Rental Mumbai, Sedan Car on Rent Mumbai, Chauffeur Dzire Mumbai, Dzire Taxi Hire Mumbai, Affordable Dzire Rental, Dzire Local Ride Mumbai, Dzire Outstation Cab Mumbai, Dzire AC Taxi Mumbai, Mumbai Airport Dzire Cab, Dzire Long Distance Cab, Dzire Corporate Cab Mumbai, Swift Dzire Hourly Rental, Dzire Day Rental Mumbai, Dzire for Office Ride Mumbai, Dzire Car Hire Near Me, Mumbai Dzire Service, Dzire Ride Booking Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/40.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Swiftdzireonrentinmumbai;